import { Injectable } from '@angular/core';

@Injectable()
export class RxntCompareService {
  constructor() {
  }

  isEqual(obj1: any, obj2: any): boolean {
    // If both are the same reference or primitives, compare directly
    if (obj1 === obj2) {
      return true;
    }

    // If types are different, they are not equal
    if (typeof obj1 !== typeof obj2) {
      return false;
    }

    const bothAreDates = obj1 instanceof Date && obj2 instanceof Date;
    const oneIsDate = obj1 instanceof Date || obj2 instanceof Date;

    if (oneIsDate && !bothAreDates) {
      return false;
    }

    if (bothAreDates) {
      return obj1.getTime() === obj2.getTime();
    }

    // If one is an array and the other is not, they are not equal
    if (Array.isArray(obj1) !== Array.isArray(obj2)) {
      return false;
    }

    // Array comparison
    if (Array.isArray(obj1)) {
      if (obj1.length !== obj2.length) {
        return false;
      }
      for (let i = 0; i < obj1.length; i++) {
        if (!this.isEqual(obj1[i], obj2[i])) {
          return false;
        }
      }
      return true;
    }

    // Object comparison (null is typeof 'object' so it's handled here)
    if (obj1 && obj2 && typeof obj1 === 'object' && typeof obj2 === 'object') {
      const keys1: string[] = this.getNonEmptyKeys(obj1);
      const keys2: string[] = this.getNonEmptyKeys(obj2);

      if (keys1.length !== keys2.length) {
        return false;
      }

      for (const key of keys1) {
        if (!keys2.includes(key) || !this.isEqual(obj1[key], obj2[key])) {
          return false;
        }
      }
      return true;
    }

    // If none of the above, the items are not equal
    return false;
  }

  private getNonEmptyKeys(obj: any): string[] {
    return Object.keys(obj).filter(key => obj[key] != null);
  }
}
